import InfoList from 'components/InfoList/InfoList'
import { useRequisitionInfo } from 'hooks/drawers/useRequisitionInfo'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { getNextAppointment } from 'controllers/TaskManager/controllers/utils'
import AlertBox from 'components/AlertBox/AlertBox'
import TaskRefusalController from 'controllers/TaskManager/TaskSubControllers/TaskRefusalController/TaskRefusalController'
import MedicalActsList from 'components/MedicalActsList/MedicalActsList'
import TaskIntervenientsController from 'controllers/TaskManager/TaskSubControllers/TaskIntervenientsController/TaskIntervenientsController'

import styles from '../../Requisition.module.sass'
import useIntervenients from 'hooks/useIntervenients'

const SurgeryRequisitionDetails = (props) => {
	const { requisition, process } = props
	const { i18n } = useGlobal()

	const {
		getSurgeryClinicalApprovalDetails,
		getSurgeryDetails,
		getPreOperativeListDetails,
		getSurgeryListDetails,
	} = useRequisitionInfo(requisition, i18n)

	const { hasIntervenient } = useIntervenients(requisition)

	const nextAppointment = getNextAppointment(requisition?.appointments)

	const preOperativeListDetails = getPreOperativeListDetails()
	const surgeryListDetails = getSurgeryListDetails()

	const isProcessInAnalysis = process.processInjuredStateId === 2

	return (
		<>
			<section>
				<TaskRefusalController requisition={requisition} />

				{[2, 3].includes(requisition?.urgency?.id) && (
					<AlertBox
						className={styles['alert-box']}
						type='warning'
						items={[
							{
								title: requisition?.urgency?.description,
								text: i18n`Surgery must be performed soon`,
							},
						]}
					/>
				)}

				{isProcessInAnalysis && (
					<AlertBox
						className={styles['alert-box']}
						type={'warning'}
						items={[
							{
								title: i18n`Warning`,
								text: i18n`The process is under review`,
							},
						]}
					/>
				)}

				{requisition?.clinicalObservation ? (
					<InfoList
						className={styles['info-list']}
						items={[
							{
								title: i18n`Medical observation`,
								text: requisition?.clinicalObservation,
								icon: 'observation',
							},
						]}
					/>
				) : null}

				{requisition?.administrativeObservation ? (
					<InfoList
						className={styles['info-list']}
						items={[
							{
								title: i18n`Administrative observation`,
								text: requisition?.administrativeObservation,
								icon: 'observation',
							},
						]}
					/>
				) : null}
			</section>

			<section>
				<InfoList
					className={styles['info-list']}
					items={getSurgeryClinicalApprovalDetails(nextAppointment)}
				/>
			</section>

			<section>
				<h4>{i18n`Surgery data`}</h4>
				<InfoList
					className={styles['info-list']}
					items={getSurgeryDetails(nextAppointment)}
				/>
			</section>

			{hasIntervenient ? (
				<section>
					<TaskIntervenientsController requisition={requisition} />
				</section>
			) : null}

			{preOperativeListDetails.length ? (
				<section>
					<MedicalActsList
						items={preOperativeListDetails}
						title={i18n`Pre-operative`}
						displayListLength
					/>
				</section>
			) : null}

			{surgeryListDetails.length ? (
				<section>
					<MedicalActsList
						items={surgeryListDetails}
						title={i18n`Surgery`}
						displayListLength
					/>
				</section>
			) : null}
		</>
	)
}

export default SurgeryRequisitionDetails
